import { useQueryClient } from "react-query";
import { FormConfig } from "../types/form";

export const useFormConfig = (): FormConfig | undefined => {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<FormConfig>("form");
};
